import { Icon, IconProps } from './Icon';

interface BalancedIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const BalancedIcon = ({ color = '#C2E2FF', gradient, ...props }: BalancedIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 46 45"
  >
    <defs>
      {gradient && (
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      )}
      <clipPath id="clip0_5287_12453">
        <rect
          width="45"
          height="45"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
    <g clipPath="url(#clip0_5287_12453)">
      <path
        d="M39.6574 25.5682C39.6574 27.7746 39.2266 29.9595 38.3895 31.998C37.5525 34.0365 36.3256 35.8887 34.779 37.449C33.2324 39.0092 31.3962 40.2468 29.3755 41.0912C27.3547 41.9355 25.1888 42.3701 23.0015 42.3701C20.8143 42.3701 18.6484 41.9355 16.6276 41.0912C14.6068 40.2468 12.7707 39.0092 11.2241 37.4489C9.67744 35.8887 8.45058 34.0365 7.61355 31.998C6.77652 29.9595 6.3457 27.7746 6.3457 25.5682L23.0015 25.5682L39.6574 25.5682Z"
        fill={gradient ? `url(#${gradient.id})` : color}
      />
      <path
        d="M36.4425 12.4189C36.4425 14.1649 36.0986 15.8937 35.4304 17.5068C34.7623 19.1199 33.7829 20.5856 32.5483 21.8202C31.3137 23.0548 29.848 24.0341 28.235 24.7023C26.6219 25.3704 24.893 25.7143 23.147 25.7143C21.401 25.7143 19.6721 25.3704 18.0591 24.7023C16.446 24.0341 14.9803 23.0548 13.7457 21.8202C12.5111 20.5856 11.5318 19.1199 10.8636 17.5068C10.1955 15.8937 9.85156 14.1648 9.85156 12.4189L23.147 12.4189H36.4425Z"
        fill={gradient ? `url(#${gradient.id})` : color}
      />
      <ellipse
        cx="23.2929"
        cy="7.45134"
        rx="5.25974"
        ry="5.11364"
        fill={gradient ? `url(#${gradient.id})` : color}
      />
    </g>
  </Icon>
);
